module.exports = __webpack_public_path__ + "img/1199964972.a3b95a6c.jpg";